@if (isMobile()) {
  <div
    class="swipe-fix"
    (swipeleft)="swipe($event.type)"
    (swiperight)="swipe($event.type)"
    (swipeup)="swipe($event.type)"
    (swipedown)="swipe($event.type)"
  >
    <ng-template [ngTemplateOutlet]="toast" />
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="toast" />
}

<ng-template #toast>
  @let selection = this.selection();

  @if (store.entities$ | async) {
    <igo-panel
      [ngClass]="getClassPanel()"
      [id]="setHeighPanelTabsMode()"
      [title]="
        selection ? getTitle(selection) : ('toastPanel.title' | translate)
      "
      (click)="onToggleClick($event)"
      tabindex="0"
      (keydown)="handleKeyboardEvent($event)"
    >
      <igo-actionbar
        id="igo-actionbar"
        panelLeftButton
        [store]="actionStore"
        [withIcon]="true"
        [icon]="icon"
        [withTitle]="actionbarMode === 'overlay'"
        [horizontal]="true"
        [mode]="actionbarMode"
      />
      @if (selection) {
        <button
          mat-icon-button
          igoStopPropagation
          panelLeftButton
          [matTooltip]="
            ((isSelectedResultOutOfView$ | async)
              ? 'toastPanel.zoomOnFeatureTooltipOutOfView'
              : 'toastPanel.zoomOnFeatureTooltip'
            ) | translate
          "
          matTooltipShowDelay="500"
          (click)="zoomTo()"
        >
          <mat-icon
            aria-hidden="false"
            [matBadge]="(isSelectedResultOutOfView$ | async) ? '!' : ''"
            matBadgeColor="accent"
            matBadgeSize="small"
            [matBadgeHidden]="(isSelectedResultOutOfView$ | async) !== true"
            >zoom_in</mat-icon
          >
        </button>
      }
      @if (hasGeoService()) {
        <button
          mat-icon-button
          igoStopPropagation
          panelLeftButton
          tooltip-position="below"
          [matTooltip]="
            ((potententialLayerisAdded$ | async)
              ? 'toastPanel.removeLayer'
              : 'toastPanel.addLayer'
            ) | translate
          "
          matTooltipShowDelay="500"
          [color]="(potententialLayerisAdded$ | async) ? 'warn' : ''"
          (click)="handleLayer()"
        >
          <mat-icon>
            {{ (potententialLayerisAdded$ | async) ? 'delete' : 'add' }}
          </mat-icon>
        </button>
      }
      @let hasMoreThanOne = results.length > 1;
      @if (hasMoreThanOne && selection) {
        <button
          [disabled]="results[0].meta.id === selection.meta.id"
          mat-icon-button
          igoStopPropagation
          panelLeftButton
          disabledInteractive
          [matTooltip]="'toastPanel.previousFeatureTooltip' | translate"
          matTooltipShowDelay="500"
          (click)="previousResult()"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
      }
      @if (hasMoreThanOne && selection) {
        <button
          [disabled]="results[results.length - 1].meta.id === selection.meta.id"
          disabledInteractive
          mat-icon-button
          igoStopPropagation
          panelRightButton
          [matTooltip]="'toastPanel.nextFeatureTooltip' | translate"
          matTooltipShowDelay="500"
          (click)="nextResult()"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
      @if (opened && isDesktop()) {
        <button
          mat-icon-button
          igoStopPropagation
          panelRightButton
          (click)="resizeWindows()"
          [matTooltip]="
            ((this.fullExtent$ | async)
              ? 'toastPanel.standardExtentTooltip'
              : 'toastPanel.fullExtentTooltip'
            ) | translate
          "
          matTooltipShowDelay="500"
        >
          <mat-icon>{{
            fullExtent ? 'collapse_content' : 'expand_content'
          }}</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        igoStopPropagation
        panelRightButton
        (click)="clear()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <div #content class="toast-content">
        @if (selection) {
          <igo-feature-details
            [map]="map"
            [feature]="selection.data"
            (htmlDisplayEvent)="setHtmlDisplay($event)"
          />
        }
        @if (!selection) {
          <igo-search-results
            [map]="map"
            [store]="store"
            [showIcons]="true"
            [withZoomButton]="withZoomButton"
            (resultFocus)="focusResult($event)"
            (resultUnfocus)="unfocusResult($event, true)"
            (resultSelect)="selectResult($event)"
            [tabsMode]="tabsMode"
          />
        }
      </div>
    </igo-panel>
  }
</ng-template>
